require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-paracel-pulp-mill-in-paraguay-a-risky-project.json") })
        }
      }, "path---en-us-project-paracel-pulp-mill-in-paraguay-a-risky-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-paracel-pulp-mill-in-paraguay-a-risky-project!./.cache/json/en-us-project-paracel-pulp-mill-in-paraguay-a-risky-project.json
// module id = 550
// module chunks = 231608221292675